import { render, staticRenderFns } from "./resourceDetailUseRecord.vue?vue&type=template&id=d9b5ce3c&scoped=true"
import script from "./resourceDetailUseRecord.vue?vue&type=script&lang=js"
export * from "./resourceDetailUseRecord.vue?vue&type=script&lang=js"
import style0 from "./resourceDetailUseRecord.vue?vue&type=style&index=0&id=d9b5ce3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_a6c7c6c484daeff6636bea47b922569f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9b5ce3c",
  null
  
)

export default component.exports